import request from "@utils/request";

export function getDataWatchList(query) {
    return request({
        url: 'alert/data/watch-list',
        method: 'get',
        params: query
    })
}
